import { THighLight } from 'src/interfaces/news';

import { FILTERS, FILTERS_NAMES } from '../../constants/news';
import { useHighlightsList } from '../../hooks/news';
import { NotFound } from '../NotFound';

import { Card } from './components/Card';
import styles from './special-projects-list.module.scss';

interface IProps {
  filters: FILTERS;
  onItemClick?: (index, item: THighLight) => void;
}

export const SpecialProjectsList: React.FC<IProps> = ({ filters, onItemClick }) => {
  const { items } = useHighlightsList();

  const filterText = filters[FILTERS_NAMES.TEXT];
  const filterTags = filters[FILTERS_NAMES.TAG];

  if (!items?.length) return null;

  const filteredList = () => {
    let list = [...items];

    if (filterText?.length > 1) {
      list = list.filter((item) => item.title.toLowerCase().includes(filters[FILTERS_NAMES.TEXT].toLowerCase()));
    }

    if (filterTags?.length) {
      list = list.filter((item) => filterTags.every((tag) => item.tags.includes(tag)));
    }

    return list;
  };
  const list = filteredList();

  if (!list?.length) return <NotFound />;

  return (
    <div className={styles.wrapper}>
      {list.map((item, index) => (
        <Card item={item} index={index} key={`special-card-${item.id}`} onClick={onItemClick} />
      ))}
    </div>
  );
};
